var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboardCellArchive"},[_c('button',{staticClass:"ssa-button button-linkStyle",on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.archivedText)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }